var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerBlindUpBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.93 20H27.07L38 9l10.93 11zM38 36a5 5 0 100 10 5 5 0 000-10zm-10 5.19a10.3 10.3 0 018.78-10.36 10.13 10.13 0 0111.45 10.74A10.33 10.33 0 0137.78 51H34v4h3.78a14.34 14.34 0 0014.44-13.16 14.131 14.131 0 00-16-15A14.31 14.31 0 0024 41.19V69h4V41.19z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_blind_up_bis.41d807bf.svg";
export { SvgC1RollerBlindUpBis as ReactComponent };